export default __webpack_public_path__ + "static/tour_06_interactive-c0cb411ff7acc078d96dd08ba9f2e3d9.jpg";